export const admins = [
  //"0xe5818d70a9b5aed2bfde4e41fbcb07dd80f8fc84",
  //"0xa059fc472c7fac3a939664a215d6948d5c85f502",
  //"0x62b8f6c85578175ec96ae8f5b229298828e37671",
  //"0x78ab05fb88d580b83ca4f90aca6056498b69747a",
  //"0x3d5f48d873c0c057800558f3bf951afe90812c06",
  //"0x822590a618788310a1cfde8da1c121144281ee44",
  //"0x3d5f48d873c0c057800558f3bf951afe90812c06",
];
